export const Error = () => {
    return (
        <div className="container">
            <h1>网站建设中</h1>
            <h2>请稍后</h2>
        </div>
    )
}